import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BaseComponent } from '../base/base.component';
import { DataService } from '../data/data.service';
import { Course } from '../data/course';
import { CourseProgressSummary, UnitProgress } from '../data/student-report';
import { Student } from '../data/student';
import { Certificate } from '../data/certificate-layout';

@Component({
  selector: 'app-certificate-display',
  templateUrl: './certificate-display.component.html',
  styleUrls: ['./certificate-display.component.css']
})
export class CertificateDisplayComponent implements OnInit {

  constructor(private dataService: DataService, private sanitizer: DomSanitizer) { }

  @Input() student: Student;
  @Input() defaultCourseCode: string;
  @Input() courses: Course[];
  selectableCourses: Course[];

  loading: boolean;
  selectedCourseCode: string;
  courseProgressSummaries: CourseProgressSummary[];
  selectedCourseCompletedUnits: UnitProgress[];
  courseCompleteCertificate: Certificate[];

  ngOnInit()
  {
    this.selectableCourses = this.courses.filter(c => c.Code != "PlacementTest");
    this.getStudentCourseProgress(this.student.ID);
  }

  getStudentCourseProgress(studentId: number): void
  {
    this.loading = true;
    this.dataService.getStudentProgressSummaryAllCourses(studentId).subscribe(r =>
    {
      this.courseProgressSummaries = r;
      var coursesWithProgress = this.courseProgressSummaries.filter(x => x.TimeSpent > 0);
      this.selectedCourseCode = this.defaultCourseCode ? this.defaultCourseCode : (coursesWithProgress && coursesWithProgress.length > 0 ? coursesWithProgress[coursesWithProgress.length - 1] : this.courseProgressSummaries[0]).CourseCode;
      if (this.selectedCourseCode == "PlacementTest") this.selectedCourseCode = "Y4-EFL";
      this.loading = false;
      this.getCompletedUnits();
    });
  }

  getCompletedUnits() {
    var selectedCourseProgressSummary = this.courseProgressSummaries.find(course => course.CourseCode === this.selectedCourseCode);
    var selectedCourseUnits = selectedCourseProgressSummary.Units;
    this.selectedCourseCompletedUnits = selectedCourseUnits.filter(unit => unit.UnitTested).sort((a,b) => b.UnitNumber - a.UnitNumber);
    var unit24 = this.selectedCourseCompletedUnits.find(u => u.UnitNumber == 24);
    if (unit24 != undefined) {
      this.courseCompleteCertificate = [this.generateLevelCertificate(this.getCourseNumber(), unit24.LastActivityCompletion)]
    }
    else{
      this.courseCompleteCertificate = [];
    }
  }

  getCourseNumber() {
    return this.courses.find(course => course.Code === this.selectedCourseCode).NumberOnly;
  }

  generateUnitCertificate(courseNumber: number, unitNumber: number, completedOn: string): Certificate {
    
    let courseRef = `K${courseNumber}`;
    let courseName = `Level_${courseNumber}`;
    if (courseNumber == 8) {
      courseRef = "OB";
      courseName = "Older_Beginner";
    } 
    return {
      previewTemplate: {
        height: 612,
        width: 792,
        src: `/assets/certificateTemplates/Certificate_${courseRef}U${unitNumber}_digital.png`
      },
      printTemplate: {
        height: 714,
        width: 924,
        src: `/assets/certificateTemplates/Certificate_${courseRef}U${unitNumber}_print.png`
      },
      downloadTemplate: {
        height: 2550,
        width: 3300,
        src: `/assets/certificateTemplates/Certificate_${courseRef}U${unitNumber}_print.png`
      },
      contents: [
        {
          xPercent: 50,
          yPercent: 82,
          widthPercent: 61,
          heightPercent: 10,
          font: '"Poppins", sans-serif',
          color: "#000000",
          text: this.student.Name
        },
        {
          xPercent: 50,
          yPercent: 90,
          widthPercent: 15,
          heightPercent: 2,
          font: '"Poppins", sans-serif',
          color: "#7F7F7F",
          text: this.formatCertificateDate(completedOn)
        }
      ],
      downloadName: `${courseName}_Unit_${unitNumber}_Certificate`,
      description: `Unit ${unitNumber}`
    }
  }

  formatCertificateDate(date: string) : string {
    if (date == null || date == undefined) return "";
    return new Intl.DateTimeFormat('en-US', {
      month: 'long',
      day: '2-digit',
      year: 'numeric'
    }).format(new Date(date));
  }

  generateLevelCertificate(courseNumber: number, completedOn: string): Certificate {
    let courseRef = `K${courseNumber}`;
    let courseName = `Level_${courseNumber}`;
    if (courseNumber == 8) {
      courseRef = "OB";
      courseName = "Older_Beginner";
    } 
    return {
      previewTemplate: {
        height: 612,
        width: 792,
        src: `/assets/certificateTemplates/Certificate_${courseRef}End_digital.png`
      },
      printTemplate: {
        height: 714,
        width: 924,
        src: `/assets/certificateTemplates/Certificate_${courseRef}End_print.png`
      },
      downloadTemplate: {
        height: 2550,
        width: 3300,
        src: `/assets/certificateTemplates/Certificate_${courseRef}End_print.png`
      },
      contents: [
        {
          xPercent: 50,
          yPercent: 41,
          widthPercent: 50,
          heightPercent: 7,
          font: '"Poppins", sans-serif',
          color: "#000000",
          text: this.student.Name
        },
        {
          xPercent: 50,
          yPercent: 90,
          widthPercent: 15,
          heightPercent: 2,
          font: '"Poppins", sans-serif',
          color: "#7F7F7F",
          text: this.formatCertificateDate(completedOn)
        }
      ],
      downloadName: `${courseName}_Complete_Certificate`,
      description: courseName.replace('_',' ')
    }
  }
}
